module.exports = __webpack_public_path__ + "static/mamaesquefazem-3f4027eeaa498240e952c22fab4143a0.jpg";